// Mobile menu
// Triggers the mobile menu when its larger than it's parent

$(document).ready(function(){
    var parentWidth = 0;
	var groups = {};

	// Generate groups by their groupId set by elements using menu-group
	$('[data-menu-group]').each(function() {
		var $this = $(this),
		groupId = $this.attr('data-menu-group');

		if (groupId in groups) {
			groups[groupId] = groups[groupId].add($this);
		} else {
			groups[groupId] = $this;
		}
	});

	// Function for each group
	$.each(groups, function(index, group) {
		var groupChildren = group.find('[data-menu-show]');
        var menuTreshold = $('[data-menu-treshold]').attr('data-menu-treshold');

		mobileMenu();
		$(window).resize(mobileMenu);

		// Measure menu + header on resize
		function mobileMenu() {
			parentWidth = $('[data-menu-measure="parent"]').width();
			menuWidth = 20;

			$('[data-menu-measure="child"]').each(function() {
				menuWidth += $(this).outerWidth();
			});

            // show elements with show: both
			$('[data-menu-show="both"]').removeClass('invisible-js');

			// Add classes
			if(menuWidth >= parentWidth || g_windowWidth <= menuTreshold) {
				$('[data-menu-show="desktop"]').addClass('invisible-js');
				$('[data-menu-show="mobile"]').removeClass('invisible');
				$('body').addClass('body_mobile-menu');
			} else {
				$('[data-menu-show="desktop"]').removeClass('invisible-js');
				$('[data-menu-show="mobile"]').addClass('invisible');
				$('body').removeClass('body_mobile-menu');
			}
		}
	});

	// Toggle mobile menu
	$("body").on('click', '.btn-mobile-menu', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('body').addClass('open-menu');
	});

    $("body").on('click', '.btn-mobile-search', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('body').addClass('open-menu');
        $('.mobile-menu .search input').val('').focus();
	});

	// Toggle overlay
	// $('body').on('click', '#mobile-overlay', function(e) {
	// 	e.preventDefault();
	// 	$('body.open-menu').removeClass('open-menu');
	// });

	// Toggle overlay
	$('body').on('click', '.mobile-menu', function(e) {
        if(e.target == this || $(e.target).hasClass('mobile-menu-close') || $(e.target).hasClass('svg-icon-close') || $(e.target).hasClass('jam-close') || $(e.target).hasClass('jam-close-path')) {
            e.preventDefault();
            $('body.open-menu').removeClass('open-menu');
        }
	});
});
